// This namespace contains only disposable downloads, never cloud originals or
// DAW projects. Clean it on account changes even if the VST window is closed.
let activeOwner: string | null = null;
let revision = 0;
export async function retainPrivateVstCache(owner: string | null) {
  activeOwner = owner;
  const current = ++revision;
  if (typeof navigator === 'undefined' || !navigator.storage?.getDirectory) return;
  try {
    const root = await navigator.storage.getDirectory();
    const privateRoot = await root.getDirectoryHandle('la-studio-vst-private-v1');
    // FileSystemDirectoryHandle's iterator is missing in some TS DOM versions.
    const keys = (privateRoot as FileSystemDirectoryHandle & { keys(): AsyncIterableIterator<string> }).keys();
    for await (const name of keys) {
      if (current !== revision) return;
      if (name !== activeOwner && /^[a-f0-9]{8}-[a-f0-9-]{27}$/i.test(name)) {
        await privateRoot.removeEntry(name, { recursive: true });
      }
    }
  } catch {
    // A missing/disabled OPFS directory must not break account authentication.
    // The open player's cleanup separately reports storage failures to the user.
  }
}
